module.exports = __webpack_public_path__ + "img/customers.2014b7d2.svg";